<template>
    <div class="ar">
        <!-- <div 
            v-if="isUploading" 
            class="aroverlay"/>

        <div 
            v-if="isUploading" 
            class="arspinner">
            <div class="dot"/>
            <div class="dot"/>
            <div class="dot"/>
        </div> -->

        <div class="arcontent">
            <div class="recorder">
                <div
                    v-if="!isRecording"
                    style="width: 100%; padding-top: 30px"
                >
                    <icon-button
                        :name="iconButtonType"
                        :class="{
                            'icon rec': isRecording,
                            'icon pulse': isRecording && volume > 0.02
                        }"
                        class="icon"
                        @click.native="toggleRecorder"
                    />
                    <div class="duration">{{ recordedTime }}</div>
                    <div
                        v-if="time"
                        class="time-limit"
                    >Take is limited to {{ time }}m</div>
                </div>
                <div
                    v-else
                    style="width: 100%"
                >
                    <icon-button
                        class="icon stop"
                        name="stop"
                        @click.native="stopRecorder"
                    />
                    <div class="duration">{{ recordedTime }}</div>
                    <div
                        v-if="time"
                        class="time-limit"
                    >Take is limited to {{ time }}m</div>
                </div>
            </div>

            <f7-block-title
                v-if="attempts"
                style="margin-left: 0px; margin-top: -20px"
                class="records-limit"
            >Select best take (max: {{ attempts }})</f7-block-title>

            <div class="records">
                <div
                    v-for="(record, idx) in recordList"
                    :key="record.id"
                    :class="`record ${record.id === selected.id ? 'selected' : ''}`"
                    @click="selected = record; takeSelected = true;"
                >
                    <div
                        v-if="record.id === selected.id"
                        class="rm"
                        @click="removeRecord(idx)"
                    >&times;</div>
                    <div class="text">Take {{ idx + 1 }}</div>
                    <div class="text">{{ record.duration }}</div>
                </div>
            </div>

            <audio-player
                :compact="compact"
                :record="selected"
                :uploader-options="uploaderOptions"
            />

            <div
                v-if="uploadStatus"
                :class="uploadStatusClasses"
            >{{ message }}</div>
        </div>
    </div>
</template>

<script>
import AudioPlayer from './player';
import IconButton from './icon-button';
import Recorder from './lib/recorder';
import { convertTimeMMSS } from './lib/utils';

export default {
    components: {
        AudioPlayer,
        IconButton
    },
    store: ['api', 'user', 'takeSelected'],
    props: {
        attempts: { type: Number, default: 0 },
        compact: { type: Boolean, default: false },
        time: { type: Number, default: 0 },

        attemptsLimit: { type: Function, default: () => { } },
        micFailed: { type: Function, default: () => { } },
        startRecord: { type: Function, default: () => { } },
        stopRecord: { type: Function, default: () => { } },

        failedUpload: { type: Function, default: () => { } },
        headers: { type: Object, default: () => new Object() },
        startUpload: { type: Function, default: () => { } },
        successfulUpload: { type: Function, default: () => { } },
        uploadUrl: { type: String, default: '' },

        successfulUploadMsg: { type: String, default: 'Upload successful' },
        failedUploadMsg: { type: String, default: 'Upload fail' }
    },
    data () {
        return {
            isUploading: false,
            recorder: new Recorder({
                afterStop: () => {
                    this.recordList = this.recorder.recordList();
                    if (this.stopRecord) {
                        this.stopRecord('stop record');
                    }
                },
                attempts: this.attempts,
                time: this.time
            }),
            recordList: [],
            selected: {},
            uploadStatus: null,
            uploaderOptions: {}
        };
    },
    computed: {
        attemptsLeft () {
            return this.attempts - this.recorder.records.length;
        },
        iconButtonType () {
            return this.isRecording && this.isPause ? 'mic' : this.isRecording ? 'pause' : 'mic';
        },
        isPause () {
            return this.recorder.isPause;
        },
        isRecording () {
            return this.recorder.isRecording;
        },
        message () {
            return this.uploadStatus === 'success' ? this.successfulUploadMsg : this.failedUploadMsg;
        },
        recordedTime () {
            if (this.time && this.recorder.duration >= this.time * 60) {
                this.stopRecorder();
            }
            return convertTimeMMSS(this.recorder.duration);
        },
        uploadStatusClasses () {
            let classes = ['status'];
            classes.push(this.uploadStatus === 'success' ? 'success' : 'fail');
            return classes.join(' ');
        },
        volume () {
            return parseFloat(this.recorder.volume);
        }
    },
    created () {
        this.uploaderOptions = {
            failedUpload: this.failedUpload,
            headers: this.headers,
            startUpload: this.startUpload,
            successfulUpload: this.successfulUpload,
            uploadUrl: this.uploadUrl
        };

        this.$events.$on('start-upload', () => {
            this.isUploading = true;
        });

        this.$events.$on('end-upload', () => {
            this.isUploading = false;
            this.uploadStatus = status;
            setTimeout(() => {
                this.uploadStatus = null;
            }, 1500);
        });
    },
    beforeDestroy () {
        this.stopRecorder();
    },
    methods: {
        toggleRecorder () {
            if (this.attempts && this.recorder.records.length >= this.attempts) {
                return;
            }

            if (!this.isRecording || (this.isRecording && this.isPause)) {
                this.recorder.start();
                if (this.startRecord) {
                    this.startRecord('start record');
                }
            } else {
                this.recorder.pause();
                if (this.startRecord) {
                    this.startRecord('pause record');
                }
            }
        },
        stopRecorder () {
            if (!this.isRecording) {
                return;
            }

            this.recorder.stop();
        },
        removeRecord (idx) {
            this.recordList.splice(idx, 1);
            this.$set(this.selected, 'url', null);
            this.$events.$emit('remove-record');
        }
    }
};
</script>

<style lang="less">
@import '../../css/colors.less';
</style>
